export interface BrandColor {
  name: string;
  hex: string;
  description?: string;
}

export interface BrandColorGroup {
  title: string;
  colors: BrandColor[];
}

/**
 * ATEK brand palette v2.1 (Dec 2025).
 * Source: 03 Reference/ATEK Brand/ATEK_Brand_Guidelines.md
 *
 * The "Primary" and "Secondary" groups are the official brand colors.
 * The "App theme (legacy)" group mirrors current tailwind atek.* and will
 * be phased out as the UI migrates to the new palette.
 */
export const BRAND_COLOR_GROUPS: BrandColorGroup[] = [
  {
    title: 'Primary',
    colors: [
      { name: 'Bone',     hex: '#F0F0F0', description: 'Backgrounds' },
      { name: 'Cobalt',   hex: '#5A1DEF', description: 'Primary CTAs, links, accents' },
      { name: 'Midnight', hex: '#1C143D', description: 'Headlines, dark sections' },
      { name: 'Slate',    hex: '#404041', description: 'Body text' },
    ],
  },
  {
    title: 'Secondary',
    colors: [
      { name: 'Punch',   hex: '#E91A60', description: 'Critical alerts only' },
      { name: 'Ice',     hex: '#A5C3B7', description: 'Info, calm messaging' },
      { name: 'Mustard', hex: '#F2D631', description: 'Warnings' },
    ],
  },
];
